import Grid from "components/Grid/Grid";
import styles from "./ROM.module.scss";
import { RomInt } from "interfaces";
import { Fragment } from "react";

const ROM = ({ header, content }: RomInt) => {
  return (
    <section className={`${styles["rom-block"]}`}>
      <h2 className={`${styles.header} bold`}>{header}</h2>
      <Grid className="four-up">
        {content.map((item, i) => (
          <Fragment key={item.label}>
            <a
              className={styles.wrapper}
              href={item.href}
              target="_blank"
              rel="noreferrer"
              aria-label={item.label}
            >
              <img
                src={item.src}
                width={item.width}
                height={item.height}
                className={styles.img}
                alt={item.label}
                // loading="lazy"
              />
              <h4 className={`${styles.label} bold`}>{item.label}</h4>
            </a>
            {i !== content.length - 1 && <div className={styles.divider} />}
          </Fragment>
        ))}
      </Grid>
    </section>
  );
};

export default ROM;
